<div>
  <cam-cms-editor-blocks [blocks]="this.getBody()"></cam-cms-editor-blocks>
</div>
